"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationModalWidget = void 0;
var React = require("react");
var reactstrap_1 = require("reactstrap");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var journey_model_1 = require("@athena-portal/journey-model");
var NotificationModalWidget = exports.NotificationModalWidget = /** @class */ (function (_super) {
    __extends(NotificationModalWidget, _super);
    function NotificationModalWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.hideModal = function () {
            _this.setState({
                show: false
            });
            _this.executeEvent("blur");
        };
        _this.state = {
            show: true
        };
        return _this;
    }
    NotificationModalWidget.prototype.render = function () {
        var title = this.getSetting("title");
        var content = this.renderHtml(this.getSetting("content"));
        var type = this.getSetting("type", "warning");
        return (React.createElement(reactstrap_1.Modal, { className: "notification-warning-modal", isOpen: this.state.show, toggle: this.hideModal },
            React.createElement(reactstrap_1.ModalHeader, { toggle: this.hideModal }, title && React.createElement(React.Fragment, null,
                type === "warning" &&
                    React.createElement("img", { className: "notification-warning-icon", src: "/img/warning-filled.svg", alt: "Attention" }),
                type === "info" &&
                    React.createElement("img", { className: "info-icon-selected", src: "/img/Flow-info-selected.svg", alt: "Info icon" }),
                React.createElement("div", { className: "text-blue-2 font-weight-medium" }, title))),
            React.createElement(reactstrap_1.ModalBody, null, content),
            React.createElement(reactstrap_1.ModalFooter, null,
                React.createElement("button", { type: "button", className: "btn btn-primary btn-next", onClick: this.hideModal }, "Ok, I understand"))));
    };
    NotificationModalWidget.prototype.renderInputField = function () {
        return React.createElement(React.Fragment, null);
    };
    NotificationModalWidget = __decorate([
        (0, journey_model_1.settings)([
            { name: "title", type: journey_model_1.TypeDescriptions.String },
            { name: "content", type: journey_model_1.TypeDescriptions.String },
            { name: "type", type: journey_model_1.TypeDescriptions.String }
        ]),
        __metadata("design:paramtypes", [Object])
    ], NotificationModalWidget);
    return NotificationModalWidget;
}(plugin_journey_1.QuestionWidgetBase));
//# sourceMappingURL=NotificationModalWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/common/NotificationModalWidget.js
// module id = 3722
// module chunks = 0